import React, { useCallback, useContext, useEffect, useState } from "react";
import "./TicketRefundPage.scss";
import { Alert, Autocomplete, Box, Button, Grid, IconButton, TextField, Typography } from "@mui/material";
import MyContext from "../../contexts/MyContext";
import Logo from "../../static/VL_Logo_CMYK_DarkBlue.png";
import { MyTextField } from "../../components/my-text-field/MyTextField";
import {
  EmailRegExp,
  MaxFileSize,
  PhoneNumberRegExp,
  SliderSettings,
  ValidTextRegExp,
  lngs,
  VLPersonalDataLink,
  PostalCodeLength,
  ValidPostalRegExp,
  NationalReserveIdentityRegExp,
  MaxNumberOfAttachments,
  TicketType,
  SingleTicketFormatRegExp,
  MovingoTicketRules,
  MaximumLengthOfOtherTicketValue,
} from "../../Constant";
import { useTranslation } from "react-i18next";
import { MyButton } from "../../components/my-button/MyButton";
import { Delete, AttachFile } from "@mui/icons-material";
import Slider from "react-slick";
import ClientSettingApiService from "../../adapters/xhr/ClientSettingApiService";
import ClaimApiService from "../../adapters/xhr/ClaimApiService";
import { getRefundTicketTypeOptions, toBase64 } from "../../Utils";
import { getConfirmation } from "../../components/my-confirmation-dialog/MyConfirmationDialog";
import { MyTheme } from "../../infrastructure/MyThemeProvider";
import { MyIdentityNumberField } from "../../components/my-identity-number-field/MyIdentityNumberField";
import PostalCodeApiService from "../../adapters/xhr/PostalCodeApiService";
import { MyCheckbox } from "../../components/my-checkbox/MyCheckbox";
import Personnummer from "personnummer";

export const TicketRefundPage = (props) => {
  const myContext = useContext(MyContext);
  let sliderRef = React.createRef();
  const { t, i18n } = useTranslation();
  const [biljettnummerValueErr, setBiljettnummerValueErr] = useState("");
  const [firstName, setFirstName] = useState("");
  const [firstNameErr, setFirstNameErr] = useState("");
  const [surName, setSurName] = useState("");
  const [surNameErr, setSurNameErr] = useState("");
  const [email, setEmail] = useState("");
  const [emailErr, setEmailErr] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [phoneNumberErr, setPhoneNumberErr] = useState("");
  const [comment, setComment] = useState("");
  const [commentErr, setCommentErr] = useState("");
  const [streetNameAndNumberValueErr, setStreetNameAndNumberValueErr] = useState("");
  const [postalCodeValueErr, setPostalCodeValueErr] = useState("");
  const [cityValueErr, setCityValueErr] = useState("");
  const [personalIDValueErr, setPersonalIDValueErr] = useState("");
  const [declareInformationErr, setDeclareInformationErr] = useState("");
  const [otherTicketTypeValueErr, setOtherTicketTypeValueErr] = useState("");
  const [error, setError] = useState(null);
  const [attachments, setAttachments] = useState([]);

  const [cityDisabled, setCityDisabled] = useState(false);
  const [validPostalCode, setValidPostalCode] = useState(false);

  const [phoneChanged, setPhoneChanged] = useState(false);
  const [emailChanged, setEmailChanged] = useState(false);

  const ticketOptions = getRefundTicketTypeOptions();
  const [ticketType, setTicketType] = React.useState(ticketOptions[0]);

  const hiddenFileInput = React.useRef(null);

  const handleClick = (event) => {
    hiddenFileInput.current.click();
  };

  const getCity = async () => {
    let response = await PostalCodeApiService.getCity(myContext.postalCode?.trim().replace(/\s/g, ""));
    if (response.isSuccess) {
      if (response.data === "") {
        setPostalCodeValueErr("you_have_entered_incorrect_zip_code");
        setValidPostalCode(false);
      } else if (response.data === null) {
        setPostalCodeValueErr("");
        setValidPostalCode(true);
      } else {
        setPostalCodeValueErr("");
        setValidPostalCode(true);
        myContext.changeCity(response.data);
        setCityDisabled(true);
      }
    }
  };

  // const fetchTickets = async () => {
  //   let response = await TicketApiService.getTicketsForPublic();
  //   if (response?.isSuccess) {
  //     let data = response.data.map((option, key) => {
  //       let rObj = {};
  //       rObj["id"] = option.id;
  //       rObj["title"] = option.title;
  //       rObj["ticketType"] = TicketType.COMMUTER;
  //       return rObj;
  //     });
  //     setPeriodTickets(data);
  //   } else {
  //     setPeriodTickets([]);
  //   }
  // };

  // useEffect(() => {
  //   if (periodTickets === null) fetchTickets();
  // }, [periodTickets]);

  // useEffect(() => {
  //   if (myContext.ticketType === TicketType.SINGLE) setTicketType(singleTicketTypeOption);
  // }, [myContext.ticketType]);

  useEffect(() => {
    if (myContext.postalCode) {
      myContext.changeCity("");
      setCityDisabled(false);
      setCityValueErr("");
      let validPostal = new RegExp(ValidPostalRegExp);
      if (validPostal.test(myContext.postalCode.trim())) {
        getCity();
      } else {
        setPostalCodeValueErr("you_have_entered_incorrect_zip_code");
      }
    } else setPostalCodeValueErr("");
  }, [myContext.postalCode]);

  const removeAttachment = (fileName) => {
    setAttachments(attachments.filter((item) => item.name !== fileName));
  };

  const handleChangeAttachment = (event) => {
    const fileUploaded = event.target.files[0];
    if (myContext.allowFileUploadExtension.find((extension) => fileUploaded.name.toLowerCase().endsWith(extension.toLowerCase())) == null)
      setError("not_allowed");
    else if (fileUploaded.size > MaxFileSize) setError("your_uploaded_file_too_big");
    else {
      setAttachments((oldArray) => [...oldArray.filter((item) => item.name !== fileUploaded.name), fileUploaded]);
      setError(null);
    }
  };

  useEffect(() => {
    if (emailChanged && email) validateEmail();
    else setEmailErr("");
  }, [email]);

  useEffect(() => {
    if (phoneChanged && phoneNumber) validatePhone();
    else setPhoneNumberErr("");
  }, [phoneNumber]);

  const validateEmail = () => {
    let validEmail = new RegExp(EmailRegExp);
    if (!email.trim()) {
      setEmailErr("email_must_be_specified");
      return false;
    } else if (!validEmail.test(email.trim())) {
      setEmailErr("email_address_is_incorrect");
      return false;
    } else setEmailErr("");
    return true;
  };

  const validatePhone = () => {
    let validPhoneNumber = new RegExp(PhoneNumberRegExp);
    if (!phoneNumber.trim()) {
      setPhoneNumberErr("mobile_number_must_be_specified");
      return false;
    } else if (!validPhoneNumber.test(phoneNumber.trim())) {
      setPhoneNumberErr("entered_invalid_phonenumber");
      return false;
    } else setPhoneNumberErr("");
    return true;
  };

  const validateTicketNumber = () => {
    let ticketValue = myContext.biljettnummerValue;
    if (ticketType.ticketType === TicketType.SINGLE) {
      const result = new RegExp(SingleTicketFormatRegExp).test(ticketValue);
      if (!result) {
        setBiljettnummerValueErr("invalid_single_ticket_format");
        return false;
      }
    }
    if (ticketType.ticketType === TicketType.COMMUTER) {
      if (ticketValue.length < MovingoTicketRules.MinLength) {
        setBiljettnummerValueErr("invalid_movingo_ticket_format");
        return false;
      }
    }
    setBiljettnummerValueErr("");
    return true;
  };

  const validate = async () => {
    let isValid = true;

    if (ticketType.ticketType !== TicketType.OTHER && !myContext.biljettnummerValue.trim()) {
      isValid = false;
      setBiljettnummerValueErr("ticketnumber_must_be_entered");
    } else {
      isValid = validateTicketNumber();
    }

    if (ticketType.ticketType === TicketType.OTHER && !myContext.otherTicketTypeValue.trim()) {
      setOtherTicketTypeValueErr("ticket_type_must_be_specified");
      isValid = false;
    } else {
      setOtherTicketTypeValueErr("");
    }

    let validNationalReserveIdentity = new RegExp(NationalReserveIdentityRegExp);
    let validPostal = new RegExp(ValidPostalRegExp);

    if (!firstName.trim()) {
      setFirstNameErr("first_name_must_be_specified");
      isValid = false;
    } else {
      setFirstNameErr("");
    }

    if (!surName.trim()) {
      setSurNameErr("surname_must_be_specified");
      isValid = false;
    } else {
      setSurNameErr("");
    }

    if (!myContext.personalID) {
      setPersonalIDValueErr("personal_id_must_be_specified");
      isValid = false;
    } else if (!Personnummer.valid(myContext.personalID) && !validNationalReserveIdentity.test(myContext.personalID.trim())) {
      setPersonalIDValueErr("invalid_person_id");
      isValid = false;
    } else setPersonalIDValueErr("");

    if (!myContext.streetNameAndNumber.trim()) {
      setStreetNameAndNumberValueErr("street_name_and_number_must_be_specified");
      isValid = false;
    } else setStreetNameAndNumberValueErr("");

    if (!myContext.city.trim()) {
      setCityValueErr("city_must_be_specified");
      isValid = false;
    } else setCityValueErr("");

    if (!myContext.postalCode.trim()) {
      setPostalCodeValueErr("postal_code_must_be_specified");
      isValid = false;
    } else if (validPostalCode == false || !validPostal.test(myContext.postalCode.trim())) {
      setPostalCodeValueErr("you_have_entered_incorrect_zip_code");
      isValid = false;
    } else setPostalCodeValueErr("");

    if (!validateEmail()) isValid = false;

    if (!validatePhone()) isValid = false;

    if (!comment.trim()) {
      setCommentErr("comment_must_be_specified");
      isValid = false;
    } else {
      setCommentErr("");
    }

    if (isValid && !myContext.declareInformation) {
      setDeclareInformationErr("ensure_info");
      isValid = false;
    } else {
      setDeclareInformationErr("");
    }

    if (isValid) {
      let result = await ClaimApiService.createTicketRefundFeedback({
        fullName: `${firstName} ${surName}`,
        email: email,
        identityNumber: myContext.personalID?.toUpperCase().trim(),
        ticketType: t(ticketType.title),
        ticketNumber: myContext.biljettnummerValue,
        ticketTypeOther: ticketType.ticketType === TicketType.OTHER ? myContext.otherTicketTypeValue : null,
        streetNameAndNumber: myContext.streetNameAndNumber?.trim(),
        mobileNumber: phoneNumber,
        postalCode: myContext.postalCode?.trim().replace(/\s/g, ""),
        city: myContext.city?.trim(),
        comment: comment,
        attachments: await Promise.all(
          attachments.map(async (attachment) => {
            return {
              file: await toBase64(attachment),
              fileName: attachment.name,
            };
          })
        ),
      });
      if (!result.isSuccess) {
        let message = t(result.errorMessage);
        const confirmed = await getConfirmation({
          message: message,
          theme: MyTheme,
        });
        if (!confirmed) window.location.reload();
      } else {
        myContext.resetState();
        setFirstName("");
        setSurName("");
        setPhoneNumber("");
        setPhoneChanged(false);
        setEmail("");
        setEmailChanged(false);
        setComment("");
        setAttachments([]);
        myContext.changeCaseNumber(result.data);
        myContext.changeActiveSlide((myContext.activeSlide += 1));
      }
    }
  };

  const getAllowedFileExtension = useCallback(async () => {
    let response = await ClientSettingApiService.GetAllowedFileExtension();
    if (response.isSuccess) {
      myContext.changeAllowFileUploadExtension(response.data);
    }
  }, []);

  useEffect(() => {
    sliderRef.slickGoTo(myContext.activeSlide, false);
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [myContext.activeSlide]);

  useEffect(() => {
    if (!myContext.allowFileUploadExtension || myContext.allowFileUploadExtension.length === 0) getAllowedFileExtension();
  }, []);

  return (
    <MyContext.Consumer>
      {(context) => (
        <Grid container className="container custom padding top-2 bottom-2 left-1 right-1" justifyContent="center">
          <Grid item>
            <div hidden={context.activeSlide !== 0}>
              <img src={Logo} className="logo" alt="VL, logo" />
            </div>
            <Slider ref={(slider) => (sliderRef = slider)} {...SliderSettings} beforeChange={(_, next) => context.changeActiveSlide(next)}>
              <div hidden={context.activeSlide !== 0} className="padding left-1 right-1">
                <Box
                  component="h1"
                  color="primary.main"
                  sx={{ marginTop: 0, marginBottom: "0.5rem", fontSize: { xs: "1.4rem", sm: "1.8rem", md: "2.2rem", lg: "2.4rem", xl: "2.6rem" } }}
                >
                  {t("ticket_refund")}
                </Box>
                <Typography component="small" sx={{ marginBottom: "1rem", display: "block" }} >
                  {t("ticket_refund_subtext")}
                </Typography>
                <p id="required-description" className="margin bottom-0">
                  <Box component="small" color="error.main">
                    *
                  </Box>
                  <small> {t("required_field")}</small>
                </p>
                <Autocomplete
                  style={{ width: "100%", margin: "1rem 0", ...props.style }}
                  options={ticketOptions}
                  getOptionLabel={(option) => t(option.title)}
                  value={ticketType}
                  onChange={(e, value) => {
                    context.changeTicketType(value.ticketType);
                    setBiljettnummerValueErr("");
                    setTicketType(value);
                    // if (value.ticketType == TicketType.COMMUTER) {
                    //   context.changeTicketId(value.id);
                    // } else {
                    //   context.changeTicketId(null);
                    // }
                  }}
                  disableClearable={true}
                  renderInput={(params) => <TextField {...params} label={t("ticket_type")} variant="outlined" />}
                />
                {ticketType.ticketType == TicketType.OTHER && (
                  <MyTextField
                    helperText={t(otherTicketTypeValueErr)}
                    autoComplete="on"
                    regExp={ValidTextRegExp}
                    value={context.otherTicketTypeValue}
                    label={t("state_which_ticket_type")}
                    required={true}
                    onChange={context.changeOtherTicketTypeValue}
                    maxLength={MaximumLengthOfOtherTicketValue}
                    onKeyPress={(e) => {
                      if (e.key === "Enter") {
                        validate();
                      }
                    }}
                  />
                )}
                <MyTextField
                  helperText={t(biljettnummerValueErr)}
                  autoComplete="on"
                  regExp={ValidTextRegExp}
                  maxLength={14}
                  value={context.biljettnummerValue}
                  label={ticketType.ticketType == TicketType.COMMUTER ? t("ticket_card_number") : t("ticket_number")}
                  required={ticketType.ticketType !== TicketType.OTHER}
                  onChange={context.changeBiljettnummerValue}
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      validate();
                    }
                  }}
                />
                <MyTextField
                  value={firstName}
                  autoComplete="given-name"
                  maxLength={100}
                  regExp={ValidTextRegExp}
                  required={true}
                  label={t("firstname")}
                  userFieldName={true}
                  helperText={t(firstNameErr)}
                  onChange={setFirstName}
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      validate();
                    }
                  }}
                />
                <MyTextField
                  value={surName}
                  autoComplete="family-name"
                  maxLength={100}
                  regExp={ValidTextRegExp}
                  required={true}
                  label={t("surname")}
                  userFieldName={true}
                  helperText={t(surNameErr)}
                  onChange={setSurName}
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      validate();
                    }
                  }}
                />
                <MyTextField
                  required={true}
                  value={context.streetNameAndNumber}
                  regExp={ValidTextRegExp}
                  label={t("street_name_and_number")}
                  userFieldName={true}
                  helperText={t(streetNameAndNumberValueErr)}
                  onChange={context.changeStreetNameAndNumber}
                  maxLength={35}
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      validate();
                    }
                  }}
                />
                <MyTextField
                  required={true}
                  value={context.postalCode}
                  label={t("postal_code")}
                  inputMode="numeric"
                  regExp={"^[0-9\\s]{0,6}$"}
                  maxLength={PostalCodeLength}
                  userFieldName={true}
                  helperText={t(postalCodeValueErr)}
                  onChange={context.changePostalCode}
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      validate();
                    }
                  }}
                />
                <MyTextField
                  required={true}
                  disabled={cityDisabled}
                  value={context.city}
                  regExp={ValidTextRegExp}
                  label={t("city")}
                  userFieldName={true}
                  helperText={t(cityValueErr)}
                  onChange={context.changeCity}
                  maxLength={35}
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      validate();
                    }
                  }}
                />
                <MyIdentityNumberField
                  required={true}
                  label={t("personal_identifications_number")}
                  userFieldName={true}
                  helperText={t(personalIDValueErr)}
                  value={context.personalID}
                  onChange={context.changePersonalID}
                  placeholder={t("personal_id_format")}
                  inputMode="numeric"
                  mask="########-####"
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      validate();
                    }
                  }}
                />
                <MyTextField
                  value={phoneNumber}
                  autoComplete="tel"
                  maxLength={15}
                  regExp={ValidTextRegExp}
                  required={true}
                  label={t("mobile_number")}
                  helperText={t(phoneNumberErr)}
                  userFieldName={true}
                  inputMode="numeric"
                  onChange={(e) => {
                    setPhoneChanged(true);
                    setPhoneNumber(e);
                  }}
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      validate();
                    }
                  }}
                />
                <MyTextField
                  value={email}
                  autoComplete="email"
                  maxLength={100}
                  regExp={ValidTextRegExp}
                  label={t("email")}
                  required={true}
                  userFieldName={true}
                  helperText={t(emailErr)}
                  onChange={(e) => {
                    setEmailChanged(true);
                    setEmail(e);
                  }}
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      validate();
                    }
                  }}
                />
                <MyTextField
                  maxLength={1000}
                  helperText={t(commentErr)}
                  regExp={ValidTextRegExp}
                  value={comment}
                  required={true}
                  onChange={setComment}
                  label={t("comment")}
                  multiline={true}
                  rows={4}
                />
                <h2 className="margin bottom-0" style={{ fontSize: "1.25rem" }}>
                  {t("do_you_need_to_attach_receipts_or_certificates")}
                </h2>
                <p>
                  <small>{t("add_up_to_3_attachments_25_MB_per_file")}</small>
                </p>
                {error && (
                  <Alert variant="filled" severity="error" className="margin top-1 bottom-1">
                    {t(error)}
                  </Alert>
                )}
                {(!attachments || attachments.length > 0) && (
                  <>
                    <hr className="margin top-0 bottom-0" aria-hidden={true} />
                    {attachments.map((item, key) => (
                      <Grid container key={key} justifyContent="space-between" alignItems={"center"}>
                        <Grid xs={10} sm={10} item color="primary.main" container wrap="nowrap" alignItems={"center"} style={{ overflowX: "hidden" }}>
                          <AttachFile fontSize="small" color="primary.main" style={{ marginRight: "1rem", marginLeft: "0.5rem" }} />
                          <Box whiteSpace={"nowrap"} component="small" color="primary.main">
                            {item.name}
                          </Box>
                        </Grid>
                        <Grid item>
                          <IconButton aria-label={t("delete")} onClick={(e) => removeAttachment(item.name)}>
                            <Delete />
                          </IconButton>
                        </Grid>
                      </Grid>
                    ))}
                  </>
                )}
                {(!attachments || attachments.length < MaxNumberOfAttachments) && (
                  <>
                    <hr className="margin top-0 bottom-0" aria-hidden={true} />
                    <Button
                      aria-haspopup="dialog"
                      variant="text"
                      className="button secondary w-100 justify-content-start"
                      style={{
                        textTransform: "unset",
                      }}

                      sx={{
                        "& span": {
                          color: "primary.main",
                        },
                        "& svg": {
                          color: "primary.main",
                        },

                      }}
                      onClick={handleClick}
                    >
                      <AttachFile fontSize="small" style={{ marginRight: "1rem" }} />
                      <span>{t("add_receipt_or_certificate")}</span>
                    </Button>
                    <input
                      accept={context.allowFileUploadExtension.map((extension) => `.${extension}`.toLowerCase()).join()}
                      type="file"
                      ref={hiddenFileInput}
                      onChange={handleChangeAttachment}
                      onClick={(event) => {
                        event.target.value = null;
                      }}
                      style={{ display: "none" }}
                    />
                  </>
                )}
                <hr className="margin top-0 bottom-0" aria-hidden={true} />
                <MyCheckbox
                  label={t("declare_information")}
                  helperText={t(declareInformationErr)}
                  checked={context.declareInformation}
                  onChange={context.changeDeclareInformation}
                  className="margin top-1"
                  style={{ marginBottom: "0.5rem" }}
                />
                <Typography sx={{ flex: "1 1 100%" }} id="tableTitle" component="p">
                  {t("read_about_how_data_processed")}
                  <Box style={{ width: "100%" }} component="a" color="primary.main" target="_blank" href={VLPersonalDataLink}>
                    {t("read_about_how_data_processed_link")}
                  </Box>
                  {`.`}
                </Typography>
                <MyButton style={{ float: "right" }} className="button primary" text={t("submit")} onClick={validate} />
              </div>
              <div hidden={context.activeSlide !== 1}>
                <Grid container spacing={3} style={{ paddingLeft: "1rem", paddingRight: "1rem" }}>
                  <Grid item xs={12} sm={12}>
                    <img src={Logo} alt="VL, logo" style={{ maxWidth: "50%", width: "50%" }} />
                  </Grid>
                  <Grid item>
                    <div dangerouslySetInnerHTML={{ __html: t("thank_you_for_your_complaint", { casenumber: context.caseNumber }) }} />
                  </Grid>
                  <Grid item>
                    <MyButton className="button primary margin top-0" text={t("submit_another_claim")} onClick={() => context.changeActiveSlide(0)} />
                  </Grid>
                </Grid>
              </div>
            </Slider>
            <div hidden={context.activeSlide !== 0}>
              <Grid item container justifyContent="center" spacing={2}>
                {Object.keys(lngs).map((lng) => (
                  <Grid item key={lng}>
                    <Typography
                      className="selector"
                      variant="overline"
                      display="block"
                      lang={lng}
                      component="button"
                      gutterBottom
                      onClick={() => {
                        i18n.changeLanguage(lng);
                        document.documentElement.lang = lng;
                      }}
                      style={{ fontWeight: i18n.language === lng ? "bold" : "normal" }}
                    >
                      {lngs[lng].nativeName}
                    </Typography>
                  </Grid>
                ))}
              </Grid>
            </div>
          </Grid>
        </Grid>
      )}
    </MyContext.Consumer>
  );
};
